"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultIcon = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importDefault(require("react"));
const defaultStyles = (theme) => ({
    iconColor: {
        color: theme.palette.primary.main
    },
    root: {
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,.12)',
        borderRadius: 10,
        justifyContent: 'center',
    },
});
const DefaultIcon = (props) => {
    const { size } = props;
    const styles = core_1.useStyles('LauncherDefaultIcon', props, defaultStyles);
    return (react_1.default.createElement(components_1.View, { style: [styles.root, { height: size, width: size, }] },
        react_1.default.createElement(components_1.DynamicIcon, { type: "icon", name: "build", color: styles.iconColor.color, size: size / 2 })));
};
exports.DefaultIcon = DefaultIcon;
exports.DefaultIcon.displayName = 'DefaultIcon';
